import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { ProjectUtils } from '../project-utils';
import { Key } from 'ts-key-enum';

@Directive({
    selector: '[AusPhoneFormat]',
    standalone: true,
})
export class AusPhoneFormatDirective {
  @Input() isMobileFormat: boolean = true;

  constructor(private el: ElementRef) {}

  @HostListener('keyup', ['$event']) onKeyUp(event: KeyboardEvent) {
    if (
      event.key !== Key.ArrowLeft &&
      event.key !== Key.ArrowDown &&
      event.key !== Key.ArrowRight &&
      event.key !== Key.ArrowUp &&
      event.key !== Key.Backspace &&
      event.key !== Key.Delete &&
      event.key !== Key.Home &&
      event.key !== Key.End
    ) {
      this.formatNumber();
    }
  }

  @HostListener('change') onChange() {
    this.formatNumber();
  }

  formatNumber(): void {
    let value = this.el.nativeElement.value.replace(/ /g, '');
    const cursorStart = this.el.nativeElement.selectionStart;
    const cursorEnd = this.el.nativeElement.selectionEnd;
    const newValue = ProjectUtils.formatPhoneNumberStringToAUSFormat(
      value,
      this.isMobileFormat
    );
    const spaceOccurance = (newValue.match(/\s/g) || []).length;
    // console.log('aus-phone-format.directive:formatNumber: value length ', value.length, ' space length ', spaceOccurance);
    // const spaceOccurance = 0;
    this.el.nativeElement.value = newValue;
    // console.log('aus-phone-format.directive:formatNumber: ', cursorStart, ' ', cursorEnd, ' ', spaceOccurance);
    if (value.length + (spaceOccurance - 1) === cursorStart) {
      this.el.nativeElement.selectionStart = cursorStart + spaceOccurance;
      this.el.nativeElement.selectionEnd = cursorEnd + spaceOccurance;
    } else {
      this.el.nativeElement.selectionStart = cursorStart;
      this.el.nativeElement.selectionEnd = cursorEnd;
    }

    /*let value = this.el.nativeElement.value.replace(/ /g, '');
    const newValue = ProjectUtils.formatPhoneNumberStringToAUSFormat(value);
    this.el.nativeElement.value = newValue;
*/
  }
}
